export class LinkData {
  imageUrl: string;
  iconUrl: string;
  videoUrl: string;
  siteName: string;
  title: string;
  description: string;
  url: string;
}
